var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 0.332031C7.79967 0.332031 0.333008 7.7987 0.333008 16.9987C0.333008 26.1987 7.79967 33.6654 16.9997 33.6654C26.1997 33.6654 33.6663 26.1987 33.6663 16.9987C33.6663 7.7987 26.1997 0.332031 16.9997 0.332031ZM16.9997 6.9987C20.2163 6.9987 22.833 9.61536 22.833 12.832C22.833 16.0487 20.2163 18.6654 16.9997 18.6654C13.783 18.6654 11.1663 16.0487 11.1663 12.832C11.1663 9.61536 13.783 6.9987 16.9997 6.9987ZM16.9997 30.332C13.6163 30.332 9.61634 28.9654 6.76634 25.532C9.68605 23.2424 13.2893 21.9981 16.9997 21.9981C20.7101 21.9981 24.3133 23.2424 27.233 25.532C24.383 28.9654 20.383 30.332 16.9997 30.332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.09a118cd41f68aa44042e12e5ebf4113.svg";
export { ForwardRef as ReactComponent };